import { render, staticRenderFns } from "./branchDetails.vue?vue&type=template&id=51fe3a7d&scoped=true"
import script from "./branchDetails.vue?vue&type=script&lang=js"
export * from "./branchDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fe3a7d",
  null
  
)

export default component.exports